import { mapActions } from "vuex";
import selectAddr from "@/components/selectAddr";
import selectRecAddr from "@/components/selectRecAddr";
import tmPicker from "@/components/tmPicker";
import moment from "moment";
import _ from "lodash";
import getMvcUrl from "../../utils/mvcUrlUtil.js";
import getCheckPhone from '@/common/js/checkPhone.js';

const stopReadOnly = {
  addrDetail: false,
  orderPlacerName: false,
  orderPlacerPhone: false,
  planArriveDt: false,
  planSendDt: false,
  jobType: false,
};

export default {
  components: {
    selectAddr,
    selectRecAddr,
    tmPicker
  },
  data() {
    // 手机号校验
    const checkPhone = getCheckPhone();
    // 手机号校验
    const checkStopPhone = getCheckPhone(false);

    return {
      datalist: [
        {
          value: 1,
          label: '周一'
        },
        {
          value: 2,
          label: '周二'
        },
        {
          value: 3,
          label: '周三'
        },
        {
          value: 4,
          label: '周四'
        },
        {
          value: 5,
          label: '周五'
        },
        {
          value: 6,
          label: '周六'
        },
        {
          value: 0,
          label: '周日'
        }
      ],
      vehicleInfo: {
        '1.8': { weight: 0.5, volumn: 3 },
        '2.7': { weight: 1, volumn: 7 },
        '3.5': { weight: 1.5, volumn: 10 },
        '4.2': { weight: 1.5, volumn: 15 },
        '5.2': { weight: 3, volumn: 20 },
        '6.2': { weight: 5, volumn: 25 },
        '7.6': { weight: 7, volumn: 35 },
        '9.6': { weight: 14, volumn: 47 },
        '13.5': { weight: 20, volumn: 75 },
        '15': { weight: 30, volumn: 87 },
        '16': { weight: 30, volumn: 120 },
        '17.5': { weight: 30, volumn: 140 }
      },
      checkAll: false,
      isIndeterminate: false,

      sx: {
        vehicleTypeName: '',
        vehicleLength: '',
      },
      bidDays: '',
      bidHours: '',
      bidMinutes: '',
      recAddressList: [],
      thirdPlaceOrder: false,
      effectLoadCapacity: '',
      systemCode: null,
      waitHandelOrderId: null,
      invokeSource: null,
      stopsDisabledSwitch: false,
      readOnly: {
        cargoInfo: false,
        volume: false,
        loadCapacity: false,
        quantity: false,
        startAddrDetail: false,
        startOrderPlacerName: false,
        startOrderPlacerPhone: false,
        startPlanArriveTm: false,
        startPlanSendtm: false,
        endAddrDetail: false,
        endOrderPlacerName: false,
        endOrderPlacerPhone: false,
        endPlanArriveTm: false,
        totalLineDistance: false,
        comment: false,
        vehicleType: false,
        vehicleLength: false,
        needReceipt: false,
        receiptAddress: false,
        receiptName: false,
        receiptPhone: false,
        hideAddStopBtn: false,
        fromApi: false
      },
      stopsReadOnly: [],
      updateSuccRes: {
        orderId: null,
        version: null
      },
      processReasons: [
        { label: '客户需求变更', value: 'R1' },
        { label: '信息填写错误', value: 'R2' },
        { label: '用车时间计划变更', value: 'R3' },
        { label: '增加押车费', value: 'R4' },
        { label: '增加装卸费', value: 'R5' },
        { label: '车辆故障', value: 'R6' },
        { label: '其它', value: 'R0' },
      ],
      isAlter: false,
      uploadUsualLineLoading: false,
      filterAddress: '',
      filename: '',
      changed: false,
      uploadBtn: true,
      activeName: 'batch',
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() + 3600 * 1000 * 24 * 6
        }
      },
      isOrdering: false,
      isOrderAltering: false,
      state: 1,
      show: {
        RobOrder: false,
        SendOrder: false,
        BidOrder: false,
      },
      addAddressVisible: false,
      driverTag: '',
      newAddress: {
        province: '',
        district: '',
        addrDetail: '',
        cityName: '',
        cityCode: '',
        coordinate: '',
        contacts: '',
        phone: '',
        shortName: '',
        rules: {
          contacts: [{ required: true, message: "请输入联系人", trigger: "blur" }],
          shortName: [{ required: true, message: "请输入地址简称", trigger: "blur" }],
          phone: [
            { required: true, message: "请选择联系方式", trigger: "blur" },
            { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: "请输入正确的联系方式", trigger: "blur" }
          ],
          addrDetail: [{ required: true, message: "请选择地址", trigger: "change" }],
        }
      },
      addressList: [],
      querystring: '',
      orderType: "single",
      activeTabName: 'first',
      mapVisible: false,
      currentTm: moment().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
      totalFee: '',
      SFMap: window.SFMap,
      map: {
        markerTpl: null,
        mapIns: null,
        vectorLayer: null,
        markersList: [],
        currVo: null,
        poiset: [],
        inputCityName: '深圳市',
        keyWord: '',
        province: '',
        district: '',
        cityCode: '',
        addrDetail: '',
        cityName: '',
        coordinateLon: null,
        coordinateLat: null,
      },
      form: {
        workDay: [],
        totalLineCount: null,
        validDate: [],
        remark: '',
        sourcePlanOrderId: '',
        cargoType: "1700",
        volume: '',
        loadCapacity: '',

        processReason: '',
        processReasonComment: '',
        isSaveFrequentlyLine: false,
        def: {
          days: 0,
          hours: 0,
          minutes: 0
        },
        "expectedPrice": '',

        "assignDriverParam": {
          "userId": '',
          "userName": '',
          "driverId": null,
          "driverName": "",
          "driverPhone": "",
          "vehicleSerial": "",
          list: [],
          vehicleId: '',
          carList: [],
        },
        "assignCarrierParam": {
          "userId": '',
          "userName": '',
          "carrierId": null,
          "carrierName": "",
          "type": 1,
        },
        "carrierAssignFlag": null,
        "carrierType": 1,
        "comment": "",
        addedComments: [],
        "dataOwner": null,
        "needReceipt": 2,
        "reachTm": '',
        "receiptAddress": "",
        "receiptName": "",
        "receiptPhone": "",
        "receiptType": 1,
        start: {
          "addrDetail": "",
          "cityCode": "",
          "cityName": "",
          "coordinate": "",
          "jobType": 1,
          "orderPlacerName": "",
          "orderPlacerPhone": "",
          "planArriveDt": '',
          "planSendDt": '',
          "seq": 1,
          departCrossDay: 0,
          arriveCrossDay: 0,
        },
        stops: [],
        end: {
          "addrDetail": "",
          "cityCode": "",
          "cityName": "",
          "coordinate": "",
          "jobType": 2,
          "lineDistance": 0,
          "orderPlacerName": "",
          "orderPlacerPhone": "",
          "planArriveDt": '',
          "planSendDt": '',
          "seq": 2,
          departCrossDay: 0,
          arriveCrossDay: 0
        },
        "planOrderPassZoneTbpList": [],
        "userId": '',
        "tenantId": '',
        "totalLineDistance": '',
        "totalRunTm": 0,
        "vehicleLength": null,
        "vehicleType": "",
        "mode": 1
      },
      checkStopPhone,
      rules: {
        validDate: [{ required: true, message: "请选择订单起止时间", trigger: "change" }],
        workDay: [{ required: true, message: "请选择运输周期", trigger: "change" }],

        processReason: [{ required: true, message: "请选择修改原因", trigger: "change" }],
        'start.addrDetail': [{ required: true, message: "请输入发货地址", trigger: "change" }],
        'start.orderPlacerName': [{ required: true, message: "请输入联系人名称", trigger: "change" }],
        'start.orderPlacerPhone': [{ required: true, trigger: "change", validator:checkPhone }],
        'start.planArriveDt': [{ required: true, message: "请输入到场时间", trigger: "change" }],
        'start.planSendDt': [{ required: true, message: "请输入计划发车时间", trigger: "change" }],

        'end.addrDetail': [{ required: true, message: "请输入收货地址", trigger: "change" }],
        'end.orderPlacerName': [{ required: true, message: "请输入联系人名称", trigger: "change" }],
        'end.orderPlacerPhone': [{ required: true, trigger: "change", validator:checkPhone }],
        'end.planArriveDt': [{ required: true, message: "请选择计划到达时间", trigger: "change" }],

        cargoType: [{ required: true, message: "请选择货物信息", trigger: "change" }],
        loadCapacity: [{ required: true, message: "请输入货物重量", trigger: "change" }],
        volume: [{ required: true, message: "请输入货物体积", trigger: "change" }],
        dataOwner: [{ required: true, message: "请选择订单归属", trigger: "change" }],

        receiptAddress: [{ required: true, message: "请输入签收地址", trigger: "change" }],
        receiptName: [{ required: true, message: "请输入联系人姓名", trigger: "change" }],
        receiptPhone: [{ required: true, trigger: "change", validator:checkPhone }],
        
        'carrierType': [{ required: true, message: "请选择承运对象", trigger: "change" }],
        'assignDriverParam.driverName': [{ required: true, message: "请输入承运司机", trigger: "change" }],
        'assignDriverParam.vehicleId': [{ required: true, message: "请选择承运车辆", trigger: "change" }],
        'assignCarrierParam.carrierName': [{ required: true, message: "请输入承运公司", trigger: "change" }],

        expectedPrice: [{ required: true, message: "请输入期望运费", trigger: "change" }],
        biddenStartTm: [{ required: true, message: "请输入竞价开始时间", trigger: "change" }],
        biddenEndTm: [{ required: true, message: "请输入竞价结束时间", trigger: "change" }],

        quantity: [
          {
            trigger: "change",
            required: false,
            validator: (rule, value, callback) => {
              if (value !== "") {
                if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) == false) {
                  callback(new Error("请填写大于0的数字"));
                } else {
                  if (Number(value) == 0) {
                    callback(new Error("请填写大于0的数字"));
                  } else {
                    callback();
                  }
                }
              } else {
                callback();
              }
            }
          }
        ]
      },
      prev: {
        "cargoInfos": [],
        "dataOwner": [],
        modes: '',
        "ownerName": "",
        "placerNames": [],
        comments: ["三不超", "需雨布", "带尾板", "无禁区", "全程高速"],
        vehicle: {
          Maps: null,
          typeMapLens: [],
          lens: [],
          "vehicleLength": null,
          "vehicleType": "",
          "plVehicleCode": ""
        },
      },
    };
  },
  watch: {
    'form.validDate': function () {
      this.calcLineNumber()
    },
    'form.workDay': function () {
      this.calcLineNumber()
    },
    /* 'prev.vehicle.vehicleLength': function (val) {
      let obj = this.vehicleInfo[val]
      this.form.volume = obj.volumn
      this.form.loadCapacity = obj.weight
    }, */

    'prev.vehicle.vehicleType': function (val) {
      this.prev.vehicle.vehicleLength = null
      this.prev.vehicle.typeMapLens.forEach(item => {
        if (item.plVehicleType == val) {
          this.prev.vehicle.plVehicleCode = item.plVehicleCode
          this.prev.vehicle.lens = item.lens
        }
      })
    },
    'form.start.coordinate': function () {
      this.calcDisAndTm()
    },
    'form.end.coordinate': function () {
      this.calcDisAndTm()
    },
    'form.stops': {
      handler: function (val) {
        if(val.length > 0) {
          let l = val.length, hasEmpty = false
          for(let i=0; i<l; i++) {
            if(!val[i].coordinate) {
              hasEmpty = true
              return
            }
          }
          if(!hasEmpty) {
            this.calcDisAndTm()
          }
        }else{
          this.calcDisAndTm()
        }
      },
      deep: true
    },
    'form.start.planSendDt': function () {
      this.calcDisAndTm();
    },
    'form.end.planArriveDt': function () {
      this.calcTotoalRunTm();
    },
    'form.totalLineDistance': function () {
      this.calcPrice();
    },
    'form.expectedPrice': _.debounce(function () {
      this.totalFee = null
      this.calcPrice()
    }, 300),
    activeTabName: _.debounce(function () {
      this.totalFee = null
      this.calcPrice()
    }, 300),
    'form.carrierType': _.debounce(function () {
      this.calcPrice()
    }, 1000),
    'tenantId': function (val) {
      this.form.tenantId = val;
    },
    'userId': function (val) {
      this.form.userId = val;
    },
    'telephone': function (val) {
      this.form.start.orderPlacerPhone = val;
    }
  },
  computed: {
    mode: function () {
      let mode = null;
      switch (this.prev.modes) {
        case '1': mode = '1'; break;
        case '2':
        case '3':
        case '1,2':
        case '1,3':
        case '2,3':
        case '1,2,3': mode = '2'; break;
        default: mode = '2'; break;
      }
      return mode
    },
    tenantId: function () {
      return this.$store.state.login.tenantId;
    },
    userId: function () {
      return this.$store.state.login.userId;
    },
    userName: function () {
      return this.$store.state.login.userName;
    },
    telephone: function () {
      return this.$store.state.login.telephone;
    },
  },
  mounted() {
    this.form.userId = this.$store.state.login.userId
    this.form.tenantId = this.$store.state.login.tenantId
    this.queryAddressList();
    this.queryCarTypeList();
    Promise.all([this.initPlaceApiIns, this.queryAddressApiIns, this.queryAddressApiIns2, this.queryCarTypeListApiIns]).then(res => {
      this.initFinishCallBack1();
      this.initFinishCallBack2();
      this.initFinishCallBack3();
    })
  },
  created() {
    let menuInterval = setInterval(() => {
      let map = JSON.parse(sessionStorage.getItem('menuMap'))
      if (map) {
        clearInterval(menuInterval)
        let submenuList = map['Shipments'].split('-');
        submenuList.forEach((item, i) => {
          this.show[item] = true;
          i == 0 && (this.activeTabName = submenuList.indexOf('SendOrder') > -1 ? 'first' : 'second')
        });
      }
    }, 30);

    this.initPlaceApiIns = this.initPlaceApi({}).then(res => {
      this.prev.cargoInfos = res.cargoInfos
      this.prev.dataOwner = res.dataOwner
      this.prev.modes = res.modes
      this.prev.ownerName = res.ownerName
      this.prev.placerNames = res.placerNames

      this.form.start.orderPlacerName = res.placerNames[0]
      if (res.dataOwner.length == 1) {
        this.form.dataOwner = res.dataOwner[0].value
      }
    }).catch(e => { });

    let time = moment().add(5, 'minutes').format("YYYY-MM-DD HH:mm")
    this.form.biddenStartTm = time + ':00'
  },
  methods: {
    ...mapActions([
      'addAddressApi',
      'queryAddressApi',
      'queryAddrByCoordinateApi',
      'queryAddrByKeywordApi',
      'initPlaceApi',
      'calcDisAndTmApi',
      'calcPriceApi',
      'planOrderAddApi',
      'getDriverInfoApi',
      'getCarrierInfoApi',
      'queryCarTypeListApi',
      'getOrderAlterInfoApi',
      'uploadToSaveOrderApiLong',
      'updateOrderApi',
      'getWaitHandleOrderByIdApi',
      'thirdPlaceOrderApi'
    ]),
    onFillTime(item, obj, key) {
      obj[key] = item.dayIndex
    },
    handleCheckAllChange(val) {
      this.form.workDay = val ? [1, 2, 3, 4, 5, 6, 0] : [];
      this.isIndeterminate = false;
    },
    handleCheckedWorkdayChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.datalist.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.datalist.length;
    },
    calcLineNumber() {
      let range = this.form.validDate;
      let workday = this.form.workDay;
      if (range.length == 0 || workday.length == 0) {
        this.form.totalLineCount = null
        return;
      }
      let start = moment(range[0])
      let end = moment(range[1])
      let lines = 0;
      workday.forEach(item => {
        let tmp = start.clone().day(item);
        if (tmp.isSame(start) || tmp.isSame(end) || tmp.isAfter(start) && tmp.isBefore(end)) {
          lines++
        }
        tmp.add(7, 'days');
        while (tmp.isBefore(end) || tmp.isSame(end)) {
          tmp.add(7, 'days');
          lines++
        }
      })
      this.form.totalLineCount = lines
    },
    biddenEndTmBlur() {
      if (!this.form.biddenStartTm || !this.form.biddenEndTm) {
        this.bidDays = ''
        this.bidHours = ''
        this.bidMinutes = ''
        return;
      } else {
        let a = moment(this.form.biddenStartTm)
        let b = moment(this.form.biddenEndTm)
        let m = b.diff(a, 'minutes')
        if (m > 0) {
          let days = moment.duration(m, 'minutes').days()
          let hours = moment.duration(m, 'minutes').hours()
          let minutes = moment.duration(m, 'minutes').minutes()
          this.bidDays = days
          this.bidHours = hours
          this.bidMinutes = minutes
        } else {
          this.$message({
            type: 'warning',
            message: '竞价结束时间必须大于开始时间'
          })
          this.bidDays = ''
          this.bidHours = ''
          this.bidMinutes = ''
          return;

        }
      }
    },
    calcEndTime() {
      if (!this.form.biddenStartTm) return;
      let total = 0;
      total = parseInt(this.bidDays ? this.bidDays : 0) * 24 * 60 + parseInt(this.bidHours ? this.bidHours : 0) * 60 + parseInt(this.bidMinutes ? this.bidMinutes : 0)
      this.form.biddenEndTm = moment(this.form.biddenStartTm).add(total, 'minutes').format('YYYY-MM-DD HH:mm:ss')
    },
    limitNumber(val) {
      let tpl = val.replace(/[^0-9.]/g, '')
      this.form.expectedPrice = tpl
    },
    onAlterOrder() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (!this.checkTm()) return;
          let params = Object.assign({}, this.form);
          this.isOrdering = true
          params.planOrderPassZoneTbpList = [params.start, ...params.stops, params.end];
          params.reachTm = params.start.planArriveDt;
          params.receiptType = (params.needReceipt == 3 ? 2 : params.needReceipt == 1 ? 1 : '');
          params.needReceipt = (params.needReceipt == 2 ? 2 : 1);

          if (this.activeTabName == 'second' || this.activeTabName == 'third') {
            params.carrierAssignFlag = 'N'
            params.vehicleType = this.prev.vehicle.plVehicleCode
            params.vehicleLength = this.prev.vehicle.vehicleLength
            params.mode = '';
          } else {
            params.carrierAssignFlag = 'Y'
            if (params.carrierType == '2') {
              params.vehicleType = this.prev.vehicle.plVehicleCode
              params.vehicleLength = this.prev.vehicle.vehicleLength
            }
            params.mode = this.mode;

          }

          if (this.activeTabName == 'second') {
            params.dispatchMode = 1
          } else if (this.activeTabName == 'third') {
            params.dispatchMode = 2
          } else {
            params.dispatchMode = 0
          }

          delete params.start;
          delete params.stops;
          delete params.end;
          delete params.def;
          delete params.addedComments;
          delete params.assignDriverParam.carList
          delete params.assignDriverParam.list
          delete params.assignDriverParam.vehicleId

          let flag = true
          for (let i = 0; i < params.planOrderPassZoneTbpList.length - 1; i++) {
            if (!this.compareTime(params.planOrderPassZoneTbpList[i].planSendDt, params.planOrderPassZoneTbpList[i + 1].planArriveDt)) {
              this.$message({
                type: 'warning',
                message: '下一地点的计划到达时间必须大于上一地点的发车时间'
              })
              flag = false;
              break;
            }
          }
          if (!flag) {
            this.isOrdering = false
            return;
          }
          params.orderId = this.alterOrderId
          this.updateOrderApi(params).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功'
            })
            this.state = 3
            Object.assign(this.form, this.$options.data().form)
            this.form.userId = this.$store.state.login.userId
            this.form.tenantId = this.$store.state.login.tenantId
            this.totalFee = ''
            this.form.uuid = ''
            this.updateSuccRes.orderId = res.orderId
            this.updateSuccRes.version = res.version

          }).catch(e => { }).finally(() => {
            this.isOrdering = false
          })
        }
      })
    },
    initFinishCallBack1() {
      this.handleUsualLineJump();
    },
    initFinishCallBack2() {
      this.alterOrderId = sessionStorage.getItem('alterOrderId')
      if (this.alterOrderId) {
        sessionStorage.removeItem('alterOrderId')
        this.isAlter = true
        this.getOrderAlterInfo();
      }
    },
    initFinishCallBack3() {
      this.handleWaitHandleOrderJump();
    },
    getOrderAlterInfo() {
      this.getOrderAlterInfoApi({ orderId: this.alterOrderId }).then(res => {
        this.isAlter_firstTrigger = true
        this.fillOrderForm(res)
        setTimeout(() => { this.isAlter_firstTrigger = false }, 100)
      }).catch(e => { });
    },
    fillOrderForm(res) {
      let dto = res.orderEditAddrDtos
      Object.assign(this.form.start, dto[0])
      Object.assign(this.form.end, dto[dto.length - 1])
      this.form.stops = [...dto.slice(1, dto.length - 1)]

      this.form.cargoInfo = res.cargoInfo
      this.form.loadCapacity = res.loadCapacity
      this.form.volume = res.volume
      this.form.sourcePlanOrderId = res.sourcePlanOrderId ? res.sourcePlanOrderId : ''

      this.form.dataOwner = res.dataOwner
      this.form.comment = res.comment
      this.form.needReceipt = res.needReceipt
      this.form.receiptAddress = res.receiptAddress
      this.form.receiptName = res.receiptName
      this.form.receiptPhone = res.receiptPhone

      this.activeTabName = (res.dispatchMode == 0 ? 'first' : 'other')
      this.form.carrierType = res.carrierType

      this.form.expectedPrice = res.price
      this.readOnly.fromApi = res.fromApi
      this.form.totalLineDistance = res.distance

    },
    onTriggerFile() {
      this.$refs.batchFile.dispatchEvent(new MouseEvent('click'))
    },
    eFileChange() {
      let dom = this.$refs.batchFile
      let file = dom.files[0]
      if (file) {
        this.changed = true
        let name = file.name
        let size = file.size
        let type = file.type
        this.filename = file.name
        this.uploadBtn = false
      } else {
        this.changed = false
        let name = null;
        let size = null;
        let type = null;
        this.filename = null;
        this.uploadBtn = true;
      }
    },
    beforeUpload(file) {
      let name = file.name.toUpperCase();
      const isExcel = name.slice(-'XLSX'.length) == 'XLSX';
      const isLt10M = file.size / 1024 / 1024 < 1;
      if (!isExcel) {
        return '上传文件只能是 xlsx 格式!';
      }
      if (!isLt10M) {
        return '上传文件大小不能超过 1MB!';
      }
      return null;
    },
    handleSuccess(res, file) {
      console.log(res, file)
    },
    handleRemove() { },
    clearUploadFile() {
      document.getElementById('cmFile').value = '';
      this.filename = '';
      this.changed = false;
      this.uploadBtn = true;
    },
    submitUpload() {
      if (!document.getElementById('cmFile').files[0]) {
        this.$message({
          type: "error",
          message: '请选择文件！'
        });
        return;
      }
      let beforeUploadResult = this.beforeUpload(document.getElementById('cmFile').files[0]);
      if (beforeUploadResult) {
        this.$message({
          type: "error",
          message: beforeUploadResult
        });
        return;
      }
      this.uploadUsualLineLoading = true;
      let formData = new window.FormData();
      formData.append('cmFile', document.getElementById('cmFile').files[0]);
      this.uploadToSaveOrderApiLong(formData, true).then(res => {
        res = JSON.parse(res.request.response).result;
        this.uploadUsualLineLoading = false;
        let tip = "导入成功记录数" + res.succSum + "条,导入失败记录数" + res.failSum + "条,详情请查看附件!";
        this.$notify({
          title: '提示',
          message: tip,
          type: 'warning',
          duration: 15000
        });
        this.clearUploadFile();
        let preUrl = getMvcUrl() + '/saas/downLoad/downLoadOssFile?objectName=' + res.filePath;
        window.open(preUrl);
      }).catch(e => {
        if (e && e.succ === 'fail' && e.msg) {
          this.$message({
            type: "error",
            message: e.msg
          });
        }
        this.uploadUsualLineLoading = false;
      }).finally(() => { });
    },
    handletTabClick() { },
    calcTotoalRunTm() {
      let planSendDt = this.form.start.planSendDt
      let planArriveDt = this.form.end.planArriveDt
      let a = moment(this.timeToDatetime(planSendDt))
      let b = moment(this.timeToDatetime(planArriveDt))
      let m = b.diff(a, 'minutes')
      if (planSendDt && planArriveDt && m > 0) {
        let days = moment.duration(m, 'minutes').days()
        let hours = moment.duration(m, 'minutes').hours()
        let minutes = moment.duration(m, 'minutes').minutes()
        this.form.totalRunTm = m
        this.form.def.days = days
        this.form.def.hours = hours
        this.form.def.minutes = minutes
      }
    },
    compareTime(startTm, endTm) {
      let result = moment(endTm).diff(moment(startTm), 'minutes')
      return result > 0;
    },
    onCheckDetail() {
      this.$router.push('/manage/OrderList')
    },
    onCheckOrderDeal() {
      sessionStorage.setItem('alterOrderId', this.updateSuccRes.orderId)
      sessionStorage.setItem('version', this.updateSuccRes.version)
      this.$router.push('/manage/OrderProcess')
    },
    onToOrderManage() {
      this.$router.push('/manage/OrderList')
    },
    onContinue() {
      this.state = 1;
    },
    queryCarTypeList() {
      this.queryCarTypeListApiIns = this.queryCarTypeListApi({}).then(res => {
        this.prev.vehicle.Maps = res;
        this.prev.vehicle.typeMapLens = res.typeMapLens;
        this.prev.vehicle.lens = res.lens;
      })
    },
    onOpenAddAddresss() {
      this.$refs.newAddressFormRef.resetFields();
    },
    oncloseAddAddresss() {
      this.$refs.newAddressFormRef.resetFields();
    },
    onAddAddress() {
      this.addAddressVisible = true
    },
    onAddAddressconfirm() {
      let params = Object.assign({}, this.newAddress)
      params.address = params.addrDetail
      delete params.addrDetail
      delete params.rules

      this.$refs.newAddressFormRef.validate((valid) => {
        if (valid) {
          this.addAddressApi(params).then(res => {
            this.$message({
              type: 'success',
              message: '新增成功'
            });
            this.addAddressVisible = false
            this.queryAddressList()
          })
        }
      })
    },
    querySearch(qs, cb) {
      let list = this.addressList;
      let results = qs ? list.filter(this.filterFun(qs)) : list;
      cb(results);
    },
    filterFun(qs) {
      return (item) => {
        return (item.shortName && item.shortName.indexOf(qs) !== -1) || item.address.indexOf(qs) !== -1 || item.contacts.indexOf(qs) !== -1 || item.phone.indexOf(qs) !== -1;
      }
    },
    handleSelect(item, obj) {
      obj.addrDetail = item.address
      obj.cityCode = item.cityCode
      obj.cityName = item.cityName
      obj.coordinate = item.coordinate
      obj.orderPlacerPhone = item.phone
      obj.orderPlacerName = item.contacts

    },
    queryAddressList() {
      this.queryAddressApiIns = this.queryAddressApi({ pageSize: 10000, pageNum: 1 }).then(res => {
        this.addressList = res.rows
      }).catch(e => { })
      this.queryAddressApiIns2 = this.queryAddressApi({ pageSize: 10000, pageNum: 1, addrType: 2 }).then(res => {
        this.recAddressList = res.rows
      }).catch(e => { })
    },
    mapCarrierStatus(status) {
      let res = '';
      switch (status) {
        case 1: res = '注册审核驳回'; break;
        case 2: res = '启用'; break;
        case 3: res = '草稿'; break;
        case 4: res = '待注册审核'; break;
        case 5: res = '黑名单'; break;
        case 11: res = '考察审核驳回'; break;
        case 12: res = '准入审核驳回'; break;
        case 41: res = '待考察审核'; break;
        case 42: res = '待准入审核'; break;
        case 7: res = '招投标黑名单'; break;
        case 8: res = '已退出'; break;
        default: res = '其他'; break;
      }
      return res
    },
    onSearchDriver(queryString, cb) {
      let params = {
        name: queryString,
        mode: '',
        planSendTm: (this.form.start.planSendDt ? this.form.start.planSendDt : this.currentTm)
      }
      this.form.assignDriverParam.carList = [];
      if (!this.form.assignDriverParam.driverName) {
        return;
      }
      this.getDriverInfoApi(params).then(res => {
        this.effectLoadCapacity = ''
        this.form.assignDriverParam.list = res
        let list = this.form.assignDriverParam.list;
        let results = queryString ? list.filter(this.createFilter(queryString)) : list;
        cb(results);
      })
    },
    createFilter(queryString) {
      return (item) => {
        return (item.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || item.mobilephone.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    onhandSelectDriver(item) {
      if (item.status != 1) {
        this.$message({
          type: 'warning',
          message: '司机未认证，请通知司机在顺陆APP进行信息验证'
        })
        /* this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        }); */
        return;
      }
      this.form.assignDriverParam.driverName = item.name
      this.form.assignDriverParam.driverId = item.driverId
      this.form.assignDriverParam.driverPhone = item.mobilephone
      this.form.assignDriverParam.userId = item.userId
      this.form.assignDriverParam.userName = item.userName
      this.form.assignDriverParam.carList = this.addFieldToCarList(item.vehicleList)
      this.driverTag = item.driverTag

    },
    addFieldToCarList(list) {
      if (list.length > 0) {
        list.forEach(item => {
          let state = item.status == 1 ? '已认证' : item.status == 2 ? '未认证' : '被占用'
          item.label = item.vehicleCode + '（' + item.vehicleTypeName + ' ' + item.vehicleLength + '米 ）' + state
          if (item.status != 1) {
            item.disabled = true
          }
        })
        return list;
      }
    },
    onSearchCarrier(queryString, cb) {
      let params = { name: queryString }
      if (!queryString) {
        return;
      }
      this.getCarrierInfoApi(params).then(res => {
        let list = res;
        let results = queryString ? list.filter(this.createFilter2(queryString)) : list;
        cb(results);
      })
    },
    createFilter2(queryString) {
      return (item) => {
        return (item.blName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    onhandSelectCarrier(item) {
      this.form.assignCarrierParam.carrierId = item.id
      this.form.assignCarrierParam.carrierName = item.blName
      // this.form.assignCarrierParam.type = item.type
      this.form.assignCarrierParam.userName = item.userName
      this.form.assignCarrierParam.userId = item.userId
    },
    onCarSelect(id) {
      this.form.assignDriverParam.carList.forEach(item => {
        if (id == item.vehicleId) {
          this.form.vehicleType = item.vehicleType
          this.form.vehicleLength = item.vehicleLength
          this.form.assignDriverParam.vehicleSerial = item.vehicleCode
          this.effectLoadCapacity = item.effectLoadCapacity
          /* 保存 */
          this.sx.vehicleTypeName = item.vehicleTypeName
          this.sx.vehicleLength = item.vehicleLength
        }
      })
    },
    checkTm() {
      let validTmRes = true
      if (!this.compareTime(this.form.start.planArriveDt, this.form.start.planSendDt)) {
        validTmRes = false
      }
      this.form.stops.forEach(item => {
        if (!this.compareTime(item.planArriveDt, item.planSendDt)) {
          validTmRes = false
        }
      });
      if (!validTmRes) {
        this.$message({
          type: 'warning',
          message: '计划发车时间必须大于到场时间'
        })
        return validTmRes
      }
      return true
    },
    checkWaitHandleOrder() {
      if (!this.checkWaitHandleOrderVehicleInfo()) {
        return false;
      }
      if (!this.checkWaitHandleOrderStatus()) {
        return false;
      }
      return true;
    },
    checkWaitHandleOrderVehicleInfo() {
      if (this.invokeSource === 'waitHandelOrder' && this.activeTabName === 'first' && this.show.SendOrder && this.form.carrierType == 1) {
        if (this.prev.vehicle.plVehicleCode && this.prev.vehicle.vehicleLength && this.form.assignDriverParam.vehicleId) {
          for (let i = 0; i < this.form.assignDriverParam.carList.length; i++) {
            if (this.form.assignDriverParam.carList[i].vehicleId == this.form.assignDriverParam.vehicleId) {
              if (this.form.assignDriverParam.carList[i].vehicleType != this.prev.vehicle.plVehicleCode) {
                this.$message({
                  type: 'error',
                  message: '承运车辆的车型不符合用车要求'
                });
                return false;
              }
              if (this.form.assignDriverParam.carList[i].vehicleLength * 1 < this.prev.vehicle.vehicleLength * 1) {
                this.$message({
                  type: 'error',
                  message: '承运车辆的车长不符合用车要求'
                });
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    checkWaitHandleOrderStatus() {
      let that = this;
      if (this.invokeSource === 'waitHandelOrder') {
        let params = {};
        params.id = this.waitHandelOrderId;
        this.getWaitHandleOrderByIdApi(params).then(res => {
          if (res.status != 0 && res.status != 3) {
            that.$message({
              type: "error",
              message: '该订单状态为已处理或已取消,不允许发货'
            });
            return false;
          }
          return true;
        }).catch(e => {
          if (e && e.succ === 'fail' && e.msg) {
            that.$message({
              type: "error",
              message: e.msg
            });
          }
          that.$message({
            type: "error",
            message: '无法获取该订单状态,不允许发货'
          });
          return false;
        }).finally(() => {

        });
      }
      return true;
    },
    /* 处理经停点字段 */
    handerStopsFields(params) {
      let list = params.planOrderPassZoneTbpList
      list.forEach((item) => {
        item.cityCodeName = item.cityName
        item.address = item.addrDetail
        item.planArriveDt = item.planArriveDt.replace(/[^0-9:]/g, '')
        item.planSendDt = item.planSendDt.replace(/[^0-9:]/g, '')
      })
    },
    onGoOrder() {//去招标
      this.$router.push('/manage/saasLineManage');
    },
    onPlaceOrder() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          /* if (!this.checkTm()) return; */
          let params = Object.assign({}, this.form);
          this.isOrdering = true;
          /* 处理上传的字段 */
          params.planOrderPassZoneTbpList = [JSON.parse(JSON.stringify(params.start)), ...JSON.parse(JSON.stringify(params.stops)), JSON.parse(JSON.stringify(params.end))];
          params.validDateStart = params.validDate[0]
          params.validDateEnd = params.validDate[1]
          params.orderCrossDay = moment(params.validDate[1]).diff(moment(params.validDate[0]), 'days') + 1
          // params.crossDay = params.def.days
          params.carMode = 1
          params.planSendTime = params.start.planSendDt.replace(/[^0-9:]/g, '');
          params.planArriveTime = params.end.planArriveDt.replace(/[^0-9:]/g, '');
          switch(params.end.planArriveDt.replace(/[0-9:]/g, '').trim()) {
            case '当天':
              params.crossDay = 0;
              break;
            case '第二天':
              params.crossDay = 1;
              break;
            case '第三天':
              params.crossDay = 2;
              break;
            case '第四天':
              params.crossDay = 3;
              break;
            case '第五天':
              params.crossDay = 4;
              break;
            case '第六天':
              params.crossDay = 5;
              break;
            case '第七天':
              params.crossDay = 6;
              break;
            case '第八天':
              params.crossDay = 7;
              break;
            case '第九天':
              params.crossDay = 8;
              break;
            case '第十天':
              params.crossDay = 9;
              break;
            default:
              params.crossDay = null;
              break;
          }
          params.receiptType = (params.needReceipt == 3 ? 2 : params.needReceipt == 1 ? 1 : null);
          params.needReceipt = (params.needReceipt == 2 ? 2 : 1);
          params.vehicleType = this.prev.vehicle.plVehicleCode
          params.vehicleLength = Number(this.prev.vehicle.vehicleLength)
          params.workDay = params.workDay.join("").replace('0', '7')
          params.dispatchMode = 3
          /* let flag = true
          for (let i = 0; i < params.planOrderPassZoneTbpList.length - 1; i++) {
            if (!this.compareTime(params.planOrderPassZoneTbpList[i].planSendDt, params.planOrderPassZoneTbpList[i + 1].planArriveDt)) {
              this.$message({
                type: 'warning',
                message: '下一地点的计划到达时间必须大于上一地点的发车时间'
              })
              flag = false;
              break;
            }
          }
          if (!flag) {
            this.isOrdering = false
            return;
          } 
          */

          /* 校验里程 */
          if (!params.totalLineDistance || params.totalLineDistance < 0 || params.totalLineDistance == 0) {
            this.$message({
              type: 'warning',
              message: '请输入正确的总里程'
            })
            this.isOrdering = false
            return;
          }
          /* 校验订单周期大于7天 */
          if (params.orderCrossDay < 8) {
            this.$message({
              type: 'warning',
              message: '订单周期需要大于7天'
            })
            this.isOrdering = false
            return;
          }
          /* 处理经停点的字段 */
          this.handerStopsFields(params);

          delete params.start;
          delete params.stops;
          delete params.end;
          delete params.def;
          delete params.addedComments;
          delete params.assignDriverParam.carList
          delete params.assignDriverParam.list
          delete params.assignDriverParam.vehicleId
          delete params.assignCarrierParam
          delete params.assignDriverParam
          this.planOrderAddApi(params).then(res => {
            this.$confirm(`订单号为：${res}`, '提交成功', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: false,
              type: 'success'
            }).then(() => {
              
            }).catch(() => {});
          }).catch(e => { }).finally(() => {
            this.isOrdering = false
          })
        }
      })
    },
    calcPrice() {
      let price = this.form.expectedPrice
      let driverTag = this.driverTag
      let distance = this.form.totalLineDistance
      let planSendTm = this.form.start.planSendDt ? this.form.start.planSendDt : this.currentTm
      let type = this.form.carrierType == '2' ? 'B' : 'C'
      let effectLoadCapacity = this.effectLoadCapacity
      let params = {
        price,
        driverTag,
        distance,
        planSendTm,
        type,
        effectLoadCapacity
      }
      if (price != '' && /^[\d.]+$/.test(price)) {
        this.totalFee = price
        this.form.totalPrice = ('' + price)
        return;
      }
      /* if (!price || !distance || this.activeTabName != 'first') {
        return;
      }
      if (type == 'B') {
        this.totalFee = price
        this.form.totalPrice = ('' + price)
        return;
      }
      this.calcPriceApi(params).then(res => {
        this.totalFee = res.price
        this.form.uuid = res.uuid
        this.form.totalPrice = ('' + res.price)
      }).catch(e => { }) */
    },
    onTabsClick() {

    },
    onAddComment(item) {
      if (this.form.addedComments.indexOf(item) == -1) {
        this.form.addedComments.push(item)
      } else {
        this.form.addedComments.pop(item)
      }
      this.form.remark = this.form.addedComments.join(' ')
    },
    onAddStop() {
      if (this.form.stops.length == 10) {
        this.$message({
          type: 'warning',
          message: '最多添加10个经停点'
        })
        return;
      }
      let seq = this.form.stops.length + 2
      let stop = {
        "addrDetail": "",
        "cityCode": "",
        "cityName": "",
        "coordinate": "",
        "jobType": null,
        "lineDistance": '',
        "orderPlacerName": "",
        "orderPlacerPhone": "",
        "planArriveDt": '',
        "planSendDt": '',
        "seq": seq,
        "departCrossDay": 0,
        "arriveCrossDay": 0
      }
      this.form.stops.push(stop);
      this.form.end.seq = seq + 1;
    },
    onDeleteStop(index) {
      let seq = this.form.stops.length
      this.form.stops.splice(index, 1);
      this.form.stops.forEach((item, index) => {
        item.seq = index + 2
      })
      this.form.end.seq = seq + 1
    },
    emapopen(obj) {
      let nodelist = document.querySelectorAll(".el-autocomplete-suggestion.el-popper");
      for (let i = 0; i < nodelist.length; i++) {
        nodelist[i].style.display = "none";
      }
    },
    onOpenMap(obj, type) {
      if (this.readOnly.fromApi) {
        return;
      }
      if ('ignore' === type) {

      }
      else if ('start' === type) {
        if (this.readOnly.startAddrDetail) {
          return;
        }
      }
      else if ('end' === type) {
        if (this.readOnly.endAddrDetail) {
          return;
        }
      } else {
        if (this.invokeSource == 'waitHandelOrder' && this.stopsReadOnly[type].addrDetail) {
          return;
        }
      }
      this.mapVisible = true;
      this.map.currVo = obj;
    },
    eMapOpened() {
      this.$refs.keywordRef.focus();
      if (!this.map.mapIns) {
        this.map.mapIns = this.SFMap.map("map", {
          center: [22.524729, 113.940159],
          zoom: 15
        });
        this.map.vectorLayer = this.SFMap.vectorLayer({ map: this.map.mapIns });
        this.map.mapIns.on("click", this.onMapClick);
      }
    },
    eMapClosed() {
      this.map.coordinate = ''
      this.map.keyWord = ''
      if (this.map.markerTpl) {
        this.map.vectorLayer.removeLayer(this.map.markerTpl);
      }
      this.removeMarkersList();
    },
    onMapClick(e) {
      this.map.coordinateLat = e.latlng.lat.toFixed(6);
      this.map.coordinateLon = e.latlng.lng.toFixed(6);
      let coordinate = this.map.coordinateLon + ',' + this.map.coordinateLat
      this.$message({
        type: 'info',
        message: '查询中...'
        , duration: 1000
      });
      if (this.map.markerTpl) {
        this.map.vectorLayer.removeLayer(this.map.markerTpl);
      }
      this.map.markerTpl = this.SFMap.marker([this.map.coordinateLat, this.map.coordinateLon]);
      this.map.vectorLayer.addLayer(this.map.markerTpl);
      this.queryAddrByCoordinateApi({ coordinate: coordinate }).then(res => {
        this.fillMapInfo(res.name, res.city, res.regcode, coordinate, res.province, res.district)
      })
    },
    mapIndex(text) {
      let i = null;
      switch (text) {
        case "当天":
          i = 0;
          break;
        case "第二天":
          i = 1;
          break;
        case "第三天":
          i = 2;
          break;
        case "第四天":
          i = 3;
          break;
        case "第五天":
          i = 4;
          break;
        case "第六天":
          i = 5;
          break;
        case "第七天":
          i = 6;
          break;
        case "第八天":
          i = 7;
          break;
        case "第九天":
          i = 8;
          break;
        case "第十天":
          i = 9;
          break;
        default:
          i = 0;
          break;
      }
      return i;
    },
    mapWeek(idx) {
      let i = '';
      switch (idx) {
        case 0:
          i = "当天";
          break;
        case 1:
          i = "第二天";
          break;
        case 2:
          i = "第三天";
          break;
        case 3:
          i = "第四天";
          break;
        case 4:
          i = "第五天";
          break;
        case 5:
          i = "第六天";
          break;
        case 6:
          i = "第七天";
          break;
        case 7:
          i = "第八天";
          break;
        case 8:
          i = "第九天";
          break;
        case 9:
          i = "第十天";
          break;
        default:
          i = '';
          break;
      }
      return i;
    },
    timeToDatetime(time) {
      if (!time) return '';
      let day = this.mapIndex(time.split(' ')[0])
      let result = moment().add(day, 'day').format('YYYY-MM-DD') + ' ' + time.split(' ')[1]
      return result;
    },
    calcDisAndTm() {
      let srcCoordinate = this.form.start.coordinate
      let destCoordinate = this.form.end.coordinate
      let planSendDt = this.timeToDatetime(this.form.start.planSendDt)
      let planDepartTm = moment().format('YYYY-MM-DD HH:mm:ss')
      if (!srcCoordinate || !destCoordinate || !planSendDt) {
        return;
      }
      let planOrderPassZoneTbpList = []
      planOrderPassZoneTbpList.push({
        seq: this.form.start.seq,
        coordinate: this.form.start.coordinate
      })
      let l = this.form.stops.length;
      if(l) {
        for(let i=0; i<l; i++) {
          planOrderPassZoneTbpList.push({
            seq: this.form.stops[i].seq,
            coordinate: this.form.stops[i].coordinate
          })
        }
      }
      planOrderPassZoneTbpList.push({
        seq: this.form.end.seq,
        coordinate: this.form.end.coordinate
      })
      let params = {
        vehicleLength: 4.2,
        planOrderPassZoneTbpList
        // srcCoordinate,
        // destCoordinate,
        // planDepartTm
      }
      this.calcDisAndTmApi(params).then(res => {
        this.form.totalLineDistance = res.distance
        this.form.totalRunTm = res.tm
        let m = res.tm
        let days = moment.duration(m, 'minutes').days()
        let hours = moment.duration(m, 'minutes').hours()
        let minutes = moment.duration(m, 'minutes').minutes()
        this.form.def.days = days
        this.form.def.hours = hours
        this.form.def.minutes = minutes
        let arrTm = moment(planSendDt).add(m, 'minutes').format('YYYY-MM-DD HH:mm')
        let arrTmYMD = arrTm.split(' ')[0]
        let arrTmHM = arrTm.split(' ')[1]
        let dd = moment(arrTmYMD).diff(moment(moment().format('YYYY-MM-DD')),'days')
        
        this.form.end.planArriveDt = this.mapWeek(dd) +' '+arrTmHM
        this.onFillTime({dayIndex:dd}, this.form.end, 'arriveCrossDay')
      })
    },
    fillMapInfo(addrDetail, cityName, cityCode, coordinate, province, district) {
      this.map.cityName = cityName;
      this.map.addrDetail = addrDetail;
      this.map.cityCode = cityCode;
      this.map.coordinate = coordinate;
      this.map.inputCityName = cityName;
      this.map.keyWord = addrDetail;

      this.map.province = province;
      this.map.district = district;
    },
    addMarker(arr) {
      let layer = this.map.vectorLayer;
      arr.forEach((item, index) => {
        let address = item.name;
        let addrDetail = item.adname + item.shortName
        let province = ''
        let o = item.lnglat.split(',')
        let coord = [o[1], o[0]]
        if (index == 0) {
          this.moveMap(coord)
        }
        if (item.adname.indexOf('省') > 0) {
          province = ''
        } else {
          province = ''
        }
        let iconMarker = this.SFMap.marker(coord, {
          iconIndex: index + 1
        }).on("click", () => {
          this.fillMapInfo(addrDetail, item.cityName, item.regcode, item.lnglat, province, item.area);
        }).bindTooltip(address);
        layer.addLayer(iconMarker);
        this.map.markersList.push(iconMarker);
      });
    },
    removeMarkersList() {
      if (this.map.markersList && this.map.markersList.length > 0) {
        for (let i = 0; i < this.map.markersList.length; i++) {
          this.map.vectorLayer.removeLayer(this.map.markersList[i]);
        }
        this.map.markersList = [];
      }
    },
    moveMap(coord) {
      this.map.mapIns.panTo(coord);
    },
    onhandleCommand(item) {
      let addrDetail = item.adname + item.shortName
      let o = item.lnglat.split(',')
      let coord = [o[1], o[0]]
      let province = ''
      if (item.adname.indexOf('省') > 0) {
        province = ''
      } else {
        province = ''
      }
      this.fillMapInfo(addrDetail, item.cityName, item.regcode, item.lnglat, province, item.area);
      this.moveMap(coord)
    },
    queryTipByKeyword(cb) {
      let params = {
        'cityName': this.map.inputCityName,
        'keyWord': this.map.keyWord,
        noFailMsg: true
      }
      if (!this.map.keyWord) {
        this.$message({
          type: 'warning',
          message: '请输入城市和地址关键字！'
        });
        this.searchList = []
        return cb(this.searchList)
      }
      this.$refs.keywordRef.activated = true
      this.queryAddrByKeywordApi(params).then(res => {
        const poiset = (res || {}).poiset || []
        this.searchList = poiset.map(ele => {
          return {
            ...ele,
            value: ele.name
          }
        })
        cb(this.searchList)
        this.map.poiset = poiset
        this.addMarker(poiset);
        if (!this.searchList.length) {
          this.$message({
            type: 'warning',
            message: '地址不存在，请重试输入地址'
          });
        }
      })
    },
    onSearchAddr(querystring, cb) {
      if (!querystring) {
        this.searchList = []
        return cb(this.searchList)
      }

      if (this.map.markerTpl) {
        this.map.vectorLayer.removeLayer(this.map.markerTpl);
      }
      if (this.map.keyWord.indexOf('市') > -1) {
        this.map.inputCityName = this.map.keyWord.split('市')[0]
      } else {
        this.map.inputCityName = ''
      }
      this.queryTipByKeyword(cb);
      this.removeMarkersList();
    },
    onAddrconfirm() {
      if (this.map.keyWord && this.searchList && this.searchList.length === 1) {
        this.onhandleCommand(this.searchList[0])
      }

      if (!this.map.keyWord || !this.map.coordinate) {
        this.$message({
          type: 'warning',
          message: '请输入关键字搜索，再选取地址！'
        });
        return;
      }
      this.map.currVo.addrDetail = this.map.addrDetail
      this.map.currVo.cityCode = this.map.cityCode
      this.map.currVo.cityName = this.map.cityName
      this.map.currVo.coordinate = this.map.coordinate

      this.map.currVo.province = this.map.province
      this.map.currVo.district = this.map.district

      this.mapVisible = false;
    },
    inputFilterAddresss(val) {
      this.addressList = this.addressList
    },
    onSelectAddr(data, form) {
      form.addrDetail = data.address
      form.cityCode = data.cityCode
      form.cityName = data.cityName
      form.coordinate = data.coordinate
      form.orderPlacerName = data.contacts
      form.orderPlacerPhone = data.phone
    },
    onSelectRecAddr(data, form) {
      form.receiptAddress = data.address
      form.receiptName = data.contacts
      form.receiptPhone = data.phone
    },

    downLoadTpl(tplName) {
      let preUrl = getMvcUrl() + '/saas/orderCore/downLoadTpl?tplName=' + tplName;
      window.open(preUrl);
    },
    handleUsualLineJump_buildPassInfo(srcObj, targetObj) {
      targetObj.addrDetail = srcObj.addrDetail;
      targetObj.cityCode = srcObj.cityCode;
      targetObj.cityName = srcObj.cityName;
      targetObj.coordinate = srcObj.coordinate;
      if (srcObj.jobType) {
        targetObj.jobType = srcObj.jobType;
      }
      if (srcObj.orderPlacerName) {
        targetObj.orderPlacerName = srcObj.orderPlacerName;
      }
      if (srcObj.orderPlacerPhone) {
        targetObj.orderPlacerPhone = srcObj.orderPlacerPhone;
      }
      targetObj.seq = srcObj.seq;
    },
    //处理常用线路通过再来一单的操作
    handleUsualLineJump() {
      let that = this;
      let paramKey = 'usualLineToShipmentsParams';
      let shipmentsObj = window.sessionStorage.getItem(paramKey);
      window.sessionStorage.removeItem(paramKey);
      if (shipmentsObj) {
        let shipmentsObjs = JSON.parse(shipmentsObj);
        this.activeName = 'single';
        this.handleUsualLineJump_buildPassInfo(shipmentsObjs.start, this.form.start);
        this.handleUsualLineJump_buildPassInfo(shipmentsObjs.end, this.form.end);
        if (shipmentsObjs.stops && shipmentsObjs.stops.length > 0) {
          for (let i = 0; i < shipmentsObjs.stops.length; i++) {
            this.onAddStop();
            this.handleUsualLineJump_buildPassInfo(shipmentsObjs.stops[i], this.form.stops[i]);
          }
        }
        this.form.dataOwner = shipmentsObjs.dataOwner;
        this.form.cargoInfo = shipmentsObjs.cargoType;
        this.form.volume = shipmentsObjs.volume;
        this.form.loadCapacity = shipmentsObjs.loadCapacity;
        this.form.comment = shipmentsObjs.comment;
        this.form.totalLineDistance = shipmentsObjs.lineDistance;
        if (shipmentsObjs.needReceipt == 1) {
          //不需要回单
          this.form.needReceipt = 2;
        }
        else if (shipmentsObjs.needReceipt == 2) {
          //需要电子回单
          this.form.needReceipt = 1;
        } else if (shipmentsObjs.needReceipt == 3) {
          //电子+纸质回单
          this.form.needReceipt = 3;
          this.form.receiptAddress = shipmentsObjs.receiptAddress;
          this.form.receiptName = shipmentsObjs.receiptName;
          this.form.receiptPhone = shipmentsObjs.receiptPhone;
        }
        this.form.expectedPrice = shipmentsObjs.expectedPrice * 1;
        for (let i = 0; i < this.prev.vehicle.typeMapLens.length; i++) {
          if (this.prev.vehicle.typeMapLens[i].plVehicleCode === shipmentsObjs.vehicleType) {
            this.prev.vehicle.vehicleType = this.prev.vehicle.typeMapLens[i].plVehicleType;
            window.setTimeout(function () { that.prev.vehicle.vehicleLength = shipmentsObjs.vehicleLength; }, 3000);
            break;
          }
        }
      }
    },
    handleWaitHandleOrderJump() {
      let fields = ['cargoInfo', 'volume', 'loadCapacity', 'quantity', 'sourcePlanOrderId', 'totalLineDistance', 'comment'];
      let that = this;
      let paramKey = 'waitHandleOrderParams';
      let shipmentsObj = window.sessionStorage.getItem(paramKey);
      window.sessionStorage.removeItem(paramKey);
      if (shipmentsObj) {
        this.invokeSource = 'waitHandelOrder';
        this.thirdPlaceOrder = true;
        this.stopsDisabledSwitch = true;
        this.readOnly.hideAddStopBtn = true;
        let shipmentsObjs = JSON.parse(shipmentsObj);
        this.activeName = 'single';
        this.waitHandelOrderId = shipmentsObjs.id;
        this.systemCode = shipmentsObjs.systemCode;

        if (shipmentsObjs.needReceipt == 1) {
          //不需要回单
          this.form.needReceipt = 2;
        }
        else if (shipmentsObjs.needReceipt == 2) {
          //需要电子回单
          this.form.needReceipt = 1;
        } else if (shipmentsObjs.needReceipt == 3) {
          //电子+纸质回单
          this.form.needReceipt = 3;
          this.form.receiptAddress = shipmentsObjs.receiptAddress;
          if (shipmentsObjs.receiptAddress) {
            this.readOnly.receiptAddress = true;
          }
          this.form.receiptName = shipmentsObjs.receiptName;
          if (shipmentsObjs.receiptName) {
            this.readOnly.receiptName = true;
          }
          this.form.receiptPhone = shipmentsObjs.receiptPhone;
          if (shipmentsObjs.receiptPhone) {
            this.readOnly.receiptPhone = true;
          }
        }

        if (shipmentsObjs.needReceipt) {
          this.readOnly.needReceipt = true;
        }

        if (shipmentsObjs.start) {
          this.handleUsualLineJump_buildPassInfo(shipmentsObjs.start, this.form.start);
          if (this.form.start.addrDetail) {
            this.readOnly.startAddrDetail = true;
          }
          if (shipmentsObjs.start.orderPlacerName) {
            this.readOnly.startOrderPlacerName = true;
          }
          if (shipmentsObjs.start.orderPlacerPhone) {
            this.readOnly.startOrderPlacerPhone = true;
          }
          this.form.start.planArriveDt = shipmentsObjs.start.planArriveDt;
          if (shipmentsObjs.start.planArriveDt) {
            this.readOnly.startPlanArriveTm = true;
          }
          this.form.start.planSendDt = shipmentsObjs.start.planSendDt;
          if (shipmentsObjs.start.planSendDt) {
            this.readOnly.startPlanSendtm = true;
          }
        }
        if (shipmentsObjs.end) {
          this.handleUsualLineJump_buildPassInfo(shipmentsObjs.end, this.form.end);
          if (this.form.end.addrDetail) {
            this.readOnly.endAddrDetail = true;
          }
          if (shipmentsObjs.end.orderPlacerName) {
            this.readOnly.endOrderPlacerName = true;
          }
          if (shipmentsObjs.end.orderPlacerPhone) {
            this.readOnly.endOrderPlacerPhone = true;
          }
          this.form.end.planArriveDt = shipmentsObjs.end.planArriveDt;
          if (shipmentsObjs.end.planArriveDt) {
            this.readOnly.endPlanArriveTm = true;
          }
        }
        if (shipmentsObjs.stops && shipmentsObjs.stops.length > 0) {
          for (let i = 0; i < shipmentsObjs.stops.length; i++) {
            this.onAddStop();
            this.stopsReadOnly.push(JSON.parse(JSON.stringify(stopReadOnly)));

            this.handleUsualLineJump_buildPassInfo(shipmentsObjs.stops[i], this.form.stops[i]);
            if (shipmentsObjs.stops[i].addrDetail) {
              this.stopsReadOnly[i].addrDetail = true;
            }
            if (shipmentsObjs.stops[i].planArriveDt) {
              this.form.stops[i].planArriveDt = shipmentsObjs.stops[i].planArriveDt;
              this.stopsReadOnly[i].planArriveDt = true;
            }
            if (shipmentsObjs.stops[i].planSendDt) {
              this.form.stops[i].planSendDt = shipmentsObjs.stops[i].planSendDt;
              this.stopsReadOnly[i].planSendDt = true;
            }
            if (shipmentsObjs.stops[i].jobType) {
              this.form.stops[i].jobType = shipmentsObjs.stops[i].jobType;
              this.stopsReadOnly[i].jobType = true;
            }

            if (shipmentsObjs.stops[i].orderPlacerPhone) {
              this.form.stops[i].orderPlacerPhone = shipmentsObjs.stops[i].orderPlacerPhone;
              this.stopsReadOnly[i].orderPlacerPhone = true;
            }

            if (shipmentsObjs.stops[i].orderPlacerName) {
              this.form.stops[i].orderPlacerName = shipmentsObjs.stops[i].orderPlacerName;
              this.stopsReadOnly[i].orderPlacerName = true;
            }

          }
        }
        for (let i = 0; i < this.prev.vehicle.typeMapLens.length; i++) {
          if (this.prev.vehicle.typeMapLens[i].plVehicleCode === shipmentsObjs.vehicleType) {
            this.prev.vehicle.vehicleType = this.prev.vehicle.typeMapLens[i].plVehicleType;
            if (shipmentsObjs.vehicleType) {
              this.readOnly.vehicleType = true;
            }
            window.setTimeout(function () {
              that.prev.vehicle.vehicleLength = shipmentsObjs.vehicleLength;
              if (shipmentsObjs.vehicleLength) {
                that.readOnly.vehicleLength = true;
              }
            }, 3000);
            break;
          }
        }

        for (let i = 0; i < fields.length; i++) {
          if (fields[i] === 'quantity') {
            if (shipmentsObjs[fields[i]] && shipmentsObjs[fields[i]] >= 0) {
              this.form[fields[i]] = shipmentsObjs[fields[i]];
            }
          } else {
            this.form[fields[i]] = shipmentsObjs[fields[i]];
          }
          if (shipmentsObjs[fields[i]]) {
            this.readOnly[fields[i]] = true;
          }
        }

        if (shipmentsObjs.expectedPrice) {
          this.form.expectedPrice = shipmentsObjs.expectedPrice;
          window.setTimeout(function () { that.calcPrice(); }, 1000);
        }

        if (this.systemCode === "SF-SX") {
          this.readOnly.fromApi = true;
        }

        this.is_shunxin_order = true;
        this.calcDisAndTm();
      }
    }
  }

};